import React, { useRef, useState, useEffect } from 'react'
import styles from './RechargeMyPoints.module.css'
import classNames from 'classnames'
import {
  Button,
  ConfigProvider,
  Input,
  InputNumber,
  message,
  Modal,
  Result,
  Space,
} from 'antd'
import { getExternalInfoListRequest } from '../../../AdminPage/JifeiXiaohaoManager/api'
import {
  getAliQrUrlRequest,
  getPayRatioListRequest,
  getPointsListRequest,
  getUserPointsRequest,
} from './api'
import { CheckCircleFilled, CloseOutlined } from '@ant-design/icons'
import NoSelectPay from './NoSelectPay'
import WeChatPay from './WeChatPay'
import AliPay from './AliPay'
import alipayImg from './alipay.svg'
import wechatImg from './weChat.svg'
import Cookies from 'js-cookie'
export default function RechargeMyPoints(props) {
  const [userPoints, setUserPoints] = useState(0)
  const [amountList, setAmountList] = useState([{
          amount: '自定义',
          jifen: 0,
        }])
  const [selectAmmountIndex, setSelectAmmountIndex] = useState(0)
  const [payWay, setPayWay] = useState(1)
  const [customAmount, setCustomAmount] = useState(10)
  const [showResult, setShowResult] = useState(false)
  const [aliOutTradeNo, setAliOutTradeNo] = useState('')
  const formContainerRef = useRef(null)

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    getPayRatioList()
    getUserPoints()
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  const getUserPoints = () => {
      getUserPointsRequest((data) => {
        if(data.ret == 1){
          Cookies.set('jifen', data.data.user_jifen)
          Cookies.set('fenpei_jifen', parseInt(data.data.user_jifen)-parseInt(data.data.school_chongzhi_shengyu_jifen))
          Cookies.set('chongzhi_jifen', data.data.school_chongzhi_shengyu_jifen)
          setUserPoints(data.data.user_jifen)
        }
      })
    }

  // 使用 formatter 和 parser 来确保输入为正整数
  // const format = value => `${value}`.replace(/\D/g, ''); // 移除非数字字符
  const formatter = (value) => {
    const [start, end] = `${value}`.split('.') || []
    const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return `${end ? `${v}.${end}` : `${v}`}`
  }
  const parse = (value) => value.replace(/\D/g, '') || undefined // 移除非数字字符或返回 undefined

  function getPayRatioList() {
    getPayRatioListRequest((res) => {
      console.log(res)
      console.log('-------=========================')
      if (res.ret == 1) {
        let tempList = res.data.map((item) => ({
          amount: item.jiage,
          jifen: parseInt(item.guding_jifen) + parseInt(item.zengsong_jifen),
        }))
        tempList.push({
          amount: '自定义',
          jifen: 0,
        })
        setAmountList(tempList)
      } else {
        message.error(res.msg)
      }
    })
  }
  return (
    <div
      className={styles.background}
      onClick={(e) => {
        props.onCancel()
        e.stopPropagation()
        e.preventDefault()
      }}
      style={{
        // width: '908px',
        marginLeft: -1,
        marginTop: -20,
        marginRight: -100,
        marginBottom: -20,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
      }}
    >
      <div
        className={styles.modalBox}
        onClick={(e) => {
          e.stopPropagation()
          e.preventDefault()
        }}
      >
        <div className={styles.titleDiv}>
          <div className={styles.title0}>充值</div>
          <div className={styles.title1}>
            {/* 剩余积分额度：{userPoints} */}
            剩余积分额度：分配积分剩余 {Cookies.get('fenpei_jifen')}&nbsp;&nbsp; 充值积分剩余 {Cookies.get('chongzhi_jifen')}
          </div>
        </div>
        <div className={styles.contentDiv}>
          <div className={styles.leftContent}>
            <div>
              <div className={styles.contentTitle}>请选择支付金额</div>
              <div
                className={classNames(
                  styles.amountBox,
                  amountList.length > 3 &&
                    selectAmmountIndex === amountList.length - 1
                    ||amountList.length>6? styles.amountBox1
                    : '',
                )}
              >
                {/* <Space size={[24, 16]} wrap> */}
                <div className={styles.amountButtonBox}>
                  {amountList.map((item, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <ConfigProvider
                      theme={{
                        components: {
                          Button: {
                            colorPrimary:
                              selectAmmountIndex === index
                                ? '#2772F0'
                                : '#fdf0da',
                            primaryColor:
                              selectAmmountIndex === index ? '#fff' : '#000',
                          },
                        },
                      }}
                    >
                      <Button
                        onClick={() => {
                          setSelectAmmountIndex(index)
                          if (index === amountList.length - 1) {
                            setCustomAmount(10)
                          }
                          if(index !== amountList.length - 1) {
                            setPayWay(1)
                          }
                          else {
                            setPayWay(0)
                          }
                          
                        }}
                        key={index}
                        variant="solid"
                        type="primary"
                        // style={{ }}
                        className={styles.amountButton}
                      >
                        {index !== amountList.length - 1 ? (
                          <div style={{ fontSize: 10 }}>
                            <span>￥</span>
                            <strong style={{ fontSize: '24px' }}>
                              {item.amount}
                            </strong>
                            <br />
                            {item.jifen}积分
                          </div>
                        ) : (
                          <div>{item.amount}</div>
                        )}
                      </Button>
                    </ConfigProvider>
                  ))}
                </div>
                {/* </Space> */}
                {selectAmmountIndex === amountList.length - 1 && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end',
                    }}
                  >
                    <ConfigProvider
                      theme={{
                        components: {
                          InputNumber: {
                            colorPrimary: '#f5b544',
                            activeBorderColor: '#f5b544',
                            hoverBorderColor: '#f5b544',
                            colorBorder: '#f5b544',
                          },
                        },
                      }}
                    >
                      <InputNumber
                        min={1}
                        max={10000}
                        prefix="￥"
                        formatter={(value) => formatter(value)} // 格式化输入值
                        parser={(value) => parse(value)} // 解析输入值
                        style={{ width: '440px', marginTop: 20 }}
                        placeholder="请输入自定义金额"
                        value={customAmount}
                        onChange={(value) => {
                          if (value < 1 || value == null) {
                            message.error('请输入大于1的金额')
                            return
                          }
                          setPayWay(0)
                          setCustomAmount(value)
                        }}
                      />
                    </ConfigProvider>
                    <div
                      style={{
                        fontSize: 10,
                        color: '#091b3d',
                        opacity: '0.6',
                        marginTop: 10,
                      }}
                    >
                      请输入1元至10000元之间的金额，￥1可兑换100积分
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div>
              <div className={payWay == 0 ? styles.payWarningTitle : ''}>
                支付方式
              </div>
              <div
                className={classNames(
                  styles.payWayBox,
                  payWay == 0 ? styles.payWayBoxBorder : '',
                )}
              >
                <div
                  className={classNames(
                    styles.wachatPay,
                    payWay === 1 ? styles.wachatPayBorder : '',
                  )}
                  onClick={() => {
                    if(selectAmmountIndex == amountList.length - 1&&customAmount == 0) {
                      message.error('充值金额不能为0')
                      return
                    }
                    setPayWay(1)
                  }}
                >
                  <img src={wechatImg} className={styles.payIcon} alt="" />
                  <div>微信支付</div>
                </div>
                <div
                  className={classNames(
                    styles.alipayPay,
                    payWay === 2 ? styles.alipayPayBorder : '',
                  )}
                  onClick={() => {
                    // alert('支付宝支付暂未开放')
                    if(selectAmmountIndex == amountList.length - 1&&customAmount == 0) {
                      message.error('充值金额不能为0')
                      return
                    }
                    setPayWay(2)
                    getAliQrUrlRequest(
                      selectAmmountIndex == amountList.length - 1
                        ? customAmount
                        : amountList[selectAmmountIndex].amount.replace(
                            '￥',
                            '',
                          ),
                      selectAmmountIndex == amountList.length - 1
                        ? customAmount * 100
                        : amountList[selectAmmountIndex].jifen,
                      (res) => {
                        setAliOutTradeNo(res.outTradeNo)
                        const htmlContent = `
                            <!DOCTYPE html>
                            <html lang="zh-CN">
                            <head>
                              <meta charset="UTF-8">
                              <title></title>
                            </head>
                            <body>
                              ${JSON.parse(res.pageRedirectionData)}
                            </body>
                            </html>
                          `

                        // 打开新窗口
                        const newWindow = window.open('', '_blank')
                        if (newWindow) {
                            newWindow.document.write(htmlContent);
                            newWindow.document.close(); // 关闭文档流，确保内容渲染完成
                          } else {
                            alert('浏览器阻止了弹出窗口，请允许弹出后重试');
                          }
                      },
                    )
                  }}
                >
                  <img src={alipayImg} className={styles.payIcon} alt="" />
                  <div>支付宝支付</div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.rightContent}>
            <div className={styles.contentTitle}>
              扫码支付
              {/* <div className={styles.orderDetail}>订单详情</div> */}
              <div className={styles.qrcodeBox}>
                {/* <img src={qrcodeImg} className={styles.qrcode} alt="" /> */}
              </div>
            </div>
            {payWay === 0 && (
              <NoSelectPay
                amount={
                  selectAmmountIndex == amountList.length - 1
                    ? customAmount
                    : amountList[selectAmmountIndex].amount.replace('￥', '')
                }
              />
            )}
            {payWay === 1 && (
              <WeChatPay
                amountListLength={amountList.length}
                ammountIndex={selectAmmountIndex}
                amount={
                  selectAmmountIndex == amountList.length - 1
                    ? customAmount
                    : amountList[selectAmmountIndex].amount.replace('￥', '')
                }
                jifen={
                  selectAmmountIndex == amountList.length - 1
                    ? customAmount * 100
                    : amountList[selectAmmountIndex].jifen
                }
                changePayWay={(way) => {
                  setPayWay(way)
                }}
              />
            )}
            <div ref={formContainerRef}></div>
            {payWay === 2 &&aliOutTradeNo!=""&& (
              <AliPay
                amount={
                  selectAmmountIndex == amountList.length - 1
                    ? customAmount
                    : amountList[selectAmmountIndex].amount.replace('￥', '')
                }
                jifen={
                  selectAmmountIndex == amountList.length - 1
                    ? 0
                    : amountList[selectAmmountIndex].jifen
                }
                changePayWay={(way) => {
                  setPayWay(way)
                  setSelectAmmountIndex(0)
                  setAliOutTradeNo("")
                }}
                outTradeNo={aliOutTradeNo}
              />
            )}
            <div style={{marginTop:10}}>
              <CheckCircleFilled
               style={{fontSize: 12,
                color: '#2772F0'}} />
              <span style={{fontSize: 12,
                color: '#091b3d',marginLeft:4}}>
                积分充值成功后不支持退款，请谨情操作
              </span>
            </div>
          </div>
        </div>
        {/* <div
          style={{
            fontSize: 12,
            color: '#091b3d',
            opacity: '0.6',
            marginTop: 20,
          }}
        >
          1RMB=100积分,积分有效期为1年
        </div> */}
      </div>
    </div>
  )
}

